import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Odometer, OdometerUnit } from '@clearroadlab/cam';

import { environment } from '../../environments/environment';
import { UsersService } from '../users/users.service';
import { filterParams, handleAPIError, ISearchParams } from '../utils';

const path = `${environment.camApi.baseUrl}/odometers`;

export interface IOdometerSearchParams extends ISearchParams {
  search?: string;
  searchIn?: string[];
  vin?: string;
}

export class OdometerSearchResult {
  count = 0;
  results: Odometer[];
}

@Injectable({
  providedIn: 'root'
})
export class OdometersService {
  public odometer: Odometer;

  constructor(
    private http: HttpClient,
    private usersService: UsersService
  ) { }

  async get({ id, vin }: Partial<Odometer>) {
    return this.http.get<Odometer>(`${path}/${vin}/${id}`, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }

  async value(vin: string) {
    return this.http.get<{ value: number; unit: OdometerUnit }>(`${path}/${vin}/value`, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }

  async list(params?: IOdometerSearchParams) {
    return this.http.get<OdometerSearchResult>(path, {
      headers: this.usersService.headers,
      params: filterParams(params)
    }).toPromise().catch(handleAPIError);
  }

  async delete({ id, vin }: Partial<Odometer>) {
    return this.http.delete(`${path}/${vin}/${id}`, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }

  async approve({ id, vin }: Partial<Odometer>, data: any) {
    return this.http.put<Odometer>(`${path}/${vin}/${id}/approve`, data, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }

  async reject({ id, vin }: Partial<Odometer>, data: any) {
    return this.http.put<Odometer>(`${path}/${vin}/${id}/reject`, data, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }
  async update({ id, vin }: Partial<Odometer>, data: any) {
    return this.http.put<Odometer>(`${path}/${vin}/${id}`, data, {
      headers: this.usersService.headers
    }).toPromise().catch(handleAPIError);
  }
}
